import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/HrishiDhondge/portfolio'
      className='link footer__link'
    >
      Hrishikesh Dhondge © 2025
    </a>
  </footer>
)

export default Footer
